import { isArray } from 'lodash';
import { themeSlug } from '@/constants/environment';
import type { QuestionType } from '@/types';

export const getMarking = (
  type: QuestionType,
  currentMarking: string[],
  updateMarking: string | string[],
): string[] => {
  let result: string[] = [];
  if (type === 'mctf' && typeof updateMarking === 'string') {
    // Per index we only allow one value e.g. 0:true OR 0:false
    // If the user already added an entry at same index, we remove it
    // If it was the same item we do not store a new value (user clicked already checked item)
    // otherwise we store the new value
    let newMarking = [];
    let exactMatch = false;

    newMarking = currentMarking.filter((item) => {
      if (item === updateMarking) {
        exactMatch = true;
      }
      return item.split(':')[0] !== updateMarking.split(':')[0];
    });

    if (!exactMatch) {
      newMarking.push(updateMarking);
    }

    result = newMarking.sort();
  } else if (type !== 'sq' && typeof updateMarking === 'string') {
    let marking = [...currentMarking];
    const indexOf = marking.indexOf(updateMarking);
    // Only allow one value for tf and sc (radio buttons)
    if (type === 'tf' || type === 'sc') {
      marking = [];
    }
    if (indexOf === -1) {
      marking.push(updateMarking);
    } else {
      marking.splice(indexOf, 1);
    }
    result = marking;
  } else if (type === 'sq' && isArray(updateMarking)) {
    result = updateMarking;
  }

  return result;
};

export const isAnswerCorrect = (type: QuestionType, answerIndex: number, solution: string[]) => {
  const correctAnswerFormat = type === 'mctf' ? `${answerIndex}:true` : answerIndex.toString();
  return solution.indexOf(correctAnswerFormat) > -1;
};

export const getCorrectLabels = (): [string, string] => {
  const correctAnswerLabel = themeSlug === 'mympu' ? 'Passend' : 'Zutreffend';
  const incorrectAnswerLabel = themeSlug === 'mympu' ? 'Nicht passend' : 'Nicht zutreffend';
  return [correctAnswerLabel, incorrectAnswerLabel];
};
